import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from './FieldDescription.module.scss';

const FieldDescription = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-description',
    defaultMessage: 'Description'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [
    field,
    meta
  ] = useField<string>({name: 'description'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={
        <div className={styles.labelContainer}>
          <span>{labelText}</span>
        </div>
      }
      value={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldDescription;
